import React from "react";
import {
  EditIcon,
  PauseIcon,
  Trash,
  ExportResult,
  RestartTIconToolbar,
} from "../../assets/icon";
import { isComplianceCampaign, isWelcomeOnboardingCampaign } from "./aiCampaignsUtils";

const ManageCampaignToolbar = ({
  isHold,
  isArchived,
  statusKey,
  statusLoading,
  onRestart,
  onHold,
  onArchive,
  onExport,
  onEdit,
  viewOnly = false,
  campaignType,
}) => {
  const isWelcomeOnboarding = isWelcomeOnboardingCampaign(campaignType);
  const isCompliance = isComplianceCampaign(campaignType);

  const showEdit = !viewOnly && statusKey === "draft";
  const showRestart =
    !viewOnly && statusKey === "hold" && !isArchived;
  const showHold =
    !viewOnly && statusKey === "active" && !isArchived && !isHold;
  // Welcome onboarding and Compliance campaigns cannot be archived
  const showArchive =
    !viewOnly &&
    !isWelcomeOnboarding &&
    !isCompliance &&
    (statusKey === "active" || statusKey === "hold" || statusKey === "draft") &&
    !isArchived;

  return (
    <div className="d-flex gap-3">
      {showRestart && (
        <div
          className="btn d-flex align-items-center gap-2 custom-button fs-16"
          onClick={onRestart}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onRestart();
            }
          }}
        >
          <RestartTIconToolbar />
          Restart
        </div>
      )}
      {showHold && (
        <div
          className="btn d-flex align-items-center gap-2 custom-button fs-16"
          onClick={onHold}
          disabled={statusLoading}
        >
          <PauseIcon />
          Hold
        </div>
      )}
      {showEdit && (
        <div
          className="btn d-flex align-items-center gap-2 custom-button fs-16"
          onClick={onEdit}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onEdit();
            }
          }}
        >
          <EditIcon />
          Edit
        </div>
      )}
      {showArchive && (
        <div
          className="btn d-flex align-items-center gap-2 custom-button fs-16"
          onClick={onArchive}
          disabled={statusLoading}
        >
          <Trash color={"#162C4E"} />
          Archive
        </div>
      )}
      <div
        className="btn d-flex align-items-center gap-2 custom-button fs-16"
        onClick={onExport}
      >
        <ExportResult color={"#162C4E"} />
        Export Result
      </div>
    </div>
  );
};

export default ManageCampaignToolbar;
